import React from "react";
import PropTypes from "prop-types";
import Toolbar from "@material-ui/core/Toolbar";
import withStyles from "components/with-styles";
import styles from "./styles/header-content.css.js";
import LocalesMenu from "./locales-menu";
import UserMenu from "./user-menu";

const HeaderContent = ({ classes, availableLocales, locale, onLocaleChange }) => (
  <Toolbar className={classes.dashboard_header_content}>
    <LocalesMenu availableLocales={availableLocales} locale={locale} onLocaleChange={onLocaleChange} />
    <UserMenu />
  </Toolbar>
);

HeaderContent.propTypes = {
  /**
   * Lista de locales disponibles
   **/
  availableLocales: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * Locale configurado para el usuario
   **/
  locale: PropTypes.string.isRequired,
  /**
   * Handler que se llama al seleccionar un locale del menú de locales
   **/
  onLocaleChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(HeaderContent);
